import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const ClientResources = () => {
  return (
    <>
      <Navbar />
      <div className="client-resources-container">
        <h1>Client Resources</h1>
        <p>This is a placeholder for the client resources section that would typically be behind authentication.</p>
      </div>
      <Footer />
    </>
  );
};

export default ClientResources; 